module.exports = __webpack_public_path__ + "fonts/Roboto-500-greek-ext10.6fb9cff.woff2";